import { SUPPORTED_LANGUAGES, type LanguageCode } from '@/types/i18n';

const STORAGE_KEY = 'pf2e_preferred_language';
const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(language => language.code);

export function isSupportedLanguage(language: string | null): language is LanguageCode {
  return !!language && SUPPORTED_LANGUAGE_CODES.includes(language as LanguageCode);
}

export function resolveInitialLanguage(defaultLanguage: LanguageCode): LanguageCode {
  let stored: string | null = null;
  try {
    stored = window.localStorage.getItem(STORAGE_KEY);
  } catch {
    // Safari private mode and restrictive storage policies may deny access.
  }
  if (isSupportedLanguage(stored)) {
    return stored;
  }

  const browserLanguage = navigator.language.split('-')[0];
  if (isSupportedLanguage(browserLanguage)) {
    return browserLanguage;
  }
  return defaultLanguage;
}

export function savePreferredLanguage(language: LanguageCode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // The in-memory preference remains active for this session.
  }
}
